import { makeStyles } from "@griffel/react";

export const useAccessibleImageStylesFabric = makeStyles({
  accessibleImageHighContrastStyles: {
    backgroundColor: "Window",
  },
});

export type AccessibleImageStylesFabric = ReturnType<typeof useAccessibleImageStylesFabric>;
